import { createEventFactory, createName } from '@cp/shared/tracking';

export const notificationEnabled = createEventFactory({
  name: createName('notification', 'enabled'),
  goalId: 'podpiska_na_pushi_aktivirovana',
  goalName: 'Подписка на пуши активирована',
});

export const notificationBannerClick = createEventFactory({
  name: createName('notification', 'banner', 'click'),
  goalId: 'nazhatie_na_vkluchite_pushi',
  goalName: 'Нажатие на кнопку "Включите уведомления чтобы не пропустить важное"',
});
